const buildPageTitle = (newTitle) => {

    const currentTitle = document.title;
    const currentTitleRight = currentTitle.substring(currentTitle.lastIndexOf('|') + 1);
    return `${newTitle} | ${currentTitleRight}`;

};

export default buildPageTitle;
